// export function defaultParams() {
//   const productType = localStorage.getItem("product-type");
//   // const productId = productType ? removeHash(JSON.parse(productType)) : 6;
//   const productId = 6;

import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { keycloak } from "..";
import { PRODUCT_ID } from "../constants/constants";
import { removeHash } from "./hash";

//   return {
//     productId: productId,
//   };
// }

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set("Authorization", `Bearer ${token}`);
  }

  defaultHeader.set("ngrok-skip-browser-warning", "true");

  const productType = localStorage.getItem("product-type");
  let resolvedProductId: string | number | undefined = undefined;

  try {
    resolvedProductId = productType
      ? (removeHash(JSON.parse(productType)) as string)
      : PRODUCT_ID;
  } catch {
    resolvedProductId = PRODUCT_ID;
  }

  const normalizedProductId = Number(resolvedProductId);
  const productId =
    Number.isFinite(normalizedProductId) && normalizedProductId > 0
      ? normalizedProductId
      : Number(PRODUCT_ID) || 6;

  defaultHeader.set("productId", productId?.toString());

  return defaultHeader;
}

export async function defaultErrorMsg(
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>
) {
  const requestUrl =
    (result?.meta as any)?.request?.url ||
    (result?.meta as any)?.response?.url ||
    "";
  const normalizedUrl = String(requestUrl).toLowerCase();
  const isAuthValidationEndpoint =
    normalizedUrl.includes("/authentication-service/v1/protected") ||
    normalizedUrl.includes("/authentication-service/v1/protected-keycloak") ||
    normalizedUrl.includes("/employee-management/v1/details-me");
  const isLocalHost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  if (
    result.error &&
    result.error?.status === 401 &&
    (result?.error?.data as any)?.message === "Unauthorized" &&
    isAuthValidationEndpoint &&
    !isLocalHost
  ) {
    try {
      await keycloak.logout();
      localStorage.clear();
    } catch (err) {
      console.error("Keycloak logout failed:", err);
    }
  }
}
